import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "cel-section-head" }
const _hoisted_3 = { class: "cel-upcoming cel-events" }
const _hoisted_4 = {
  key: 0,
  class: "cel-empty"
}
const _hoisted_5 = { class: "cel-bigdate" }
const _hoisted_6 = { class: "cel-bigdate-mon" }
const _hoisted_7 = { class: "cel-bigdate-day" }
const _hoisted_8 = { class: "cel-upcoming-main" }
const _hoisted_9 = { class: "cel-upcoming-name" }
const _hoisted_10 = { class: "cel-upcoming-sub" }
const _hoisted_11 = {
  key: 0,
  class: "cel-event-desc"
}
const _hoisted_12 = { class: "cel-upcoming-days" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "cel-upcoming" }
const _hoisted_15 = {
  key: 0,
  class: "cel-empty"
}
const _hoisted_16 = { class: "cel-bigdate" }
const _hoisted_17 = { class: "cel-bigdate-mon" }
const _hoisted_18 = { class: "cel-bigdate-day" }
const _hoisted_19 = { class: "cel-upcoming-main" }
const _hoisted_20 = { class: "cel-upcoming-name" }
const _hoisted_21 = { class: "cel-upcoming-sub" }
const _hoisted_22 = { class: "cel-upcoming-days" }
const _hoisted_23 = {
  class: "cel-section-head",
  style: {"margin-top":"35px"}
}
const _hoisted_24 = { class: "cel-legend" }
const _hoisted_25 = {
  key: 1,
  class: "cel-empty"
}
const _hoisted_26 = { class: "cel-grid" }
const _hoisted_27 = { class: "cel-month-name" }
const _hoisted_28 = { class: "cel-month-list" }
const _hoisted_29 = { class: "cel-month-name-cell" }
const _hoisted_30 = { class: "cel-month-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_forge_page_button = _resolveComponent("forge-page-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Team"),
        _createElementVNode("div", { class: "page-bar-main" }, "Celebrations")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view celebrations' : 'hide')
    }, [
      (_ctx.events.length || _ctx.isTeamHubAdmin)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "cel-eyebrow" }, "Team Events", -1)),
              _createVNode(_component_forge_page_button, {
                kinds: ['event'],
                label: "Plan an event with AI",
                onApplied: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadEvents()))
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              (!_ctx.events.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No team events coming up."))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (ev) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: ev.ID,
                  class: "cel-upcoming-row"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$store.state.monthShortStrings[Number(ev.Date.slice(5, 7))].toUpperCase()), 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(Number(ev.Date.slice(8, 10))), 1)
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "cel-dot cel-dot-event" }, null, -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(ev.Name), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.eventWhen(ev)), 1),
                    (ev.Description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(ev.Description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.daysAwayText(_ctx.daysUntil(ev.Date))) + " ", 1),
                    (_ctx.isTeamHubAdmin)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "cel-remove",
                          onClick: _withModifiers(($event: any) => (_ctx.removeEvent(ev)), ["prevent"])
                        }, _toDisplayString(_ctx.removing == ev.ID ? 'Confirm remove' : 'Remove'), 9, _hoisted_13))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "cel-section-head",
        style: _normalizeStyle(_ctx.events.length || _ctx.isTeamHubAdmin ? 'margin-top:35px' : '')
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "cel-eyebrow" }, "Coming Up", -1),
        _createElementVNode("div", { class: "cel-eyebrow" }, "Next 60 Days", -1)
      ]))], 4),
      _createElementVNode("div", _hoisted_14, [
        (!_ctx.comingUp.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, "No celebrations in the next 60 days."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comingUp, (c, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "cel-upcoming-row"
          }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$store.state.monthShortStrings[c.month].toUpperCase()), 1),
              _createElementVNode("div", _hoisted_18, _toDisplayString(c.day), 1)
            ]),
            _createElementVNode("div", {
              class: "cel-dot",
              style: _normalizeStyle({ background: _ctx.typeColor(c.celName) })
            }, null, 4),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(c.emp), 1),
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.comingUpText(c)), 1)
            ]),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.daysAwayText(c.numDays)), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_23, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "cel-eyebrow" }, "All Year", -1)),
        _createElementVNode("div", _hoisted_24, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.celTypes, (t, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              class: "cel-legend-item"
            }, [
              _createElementVNode("span", {
                class: "cel-dot",
                style: _normalizeStyle({ background: _ctx.typeColor(t) })
              }, null, 4),
              _createTextVNode(_toDisplayString(t), 1)
            ]))
          }), 128))
        ])
      ]),
      (!_ctx.cels.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, "No celebration fields have been configured yet."))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthsGrouped, (group) => {
          return (_openBlock(), _createElementBlock("div", {
            key: group.month,
            class: "cel-month-card"
          }, [
            _createElementVNode("div", _hoisted_27, _toDisplayString(group.name), 1),
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (c, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "cel-month-row"
                }, [
                  _createElementVNode("span", {
                    class: "cel-dot",
                    style: _normalizeStyle({ background: _ctx.typeColor(c.celName) })
                  }, null, 4),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(c.emp), 1),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.gridValue(c)), 1)
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ], 2)
  ]))
}